import { Bandage, Bomb, Flame, Radiation, Shrink, Skull, type LucideIcon } from 'lucide-react';

/** UN class / division prefixes in the order of legacy `DangerousGoodsClass.getIconClass`; the first match wins. */
const CLASS_ICONS: [prefixes: string[], icon: LucideIcon][] = [
  [['1', '4.2'], Bomb],
  [['2.1', '3', '4.1', '4.3', '5.1', '5.2'], Flame],
  [['2.2'], Shrink],
  [['2', '6.1'], Skull],
  [['7'], Radiation],
  [['8'], Bandage]
];

/** Icon of a UN hazard class as legacy draws it; an unknown or missing class gets the radiation sign, as there. */
export const dangerousGoodIcon = (classOrDivision?: string | null): LucideIcon =>
  CLASS_ICONS.find(([prefixes]) => prefixes.some((prefix) => classOrDivision?.startsWith(prefix)))?.[1] ?? Radiation;
